"use client";
import {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
} from "react";

interface IMapContext {
  openMap: () => void;
  resetMapState: () => void;
  closeMap: () => void;
  isMapVisible: boolean;
  setIsMapVisible: Dispatch<SetStateAction<boolean>>;
  chosenLocation:
    | {
        formattedAddress: string;
        city: {
          long_name: string;
          short_name: string;
          types: string[];
        };
        region: {
          long_name: string;
          short_name: string;
          types: string[];
        };
        country: {
          long_name: string;
          short_name: string;
          types: string[];
        };
        streetNumber: {
          long_name: string;
          short_name: string;
          types: string[];
        };
        street: {
          long_name: string;
          short_name: string;
          types: string[];
        };
        position: { lat: number; lng: number };
      }
    | undefined;
  setChosenLocation: Dispatch<
    SetStateAction<
      | {
          formattedAddress: string;
          city: {
            long_name: string;
            short_name: string;
            types: string[];
          };
          region: {
            long_name: string;
            short_name: string;
            types: string[];
          };
          country: {
            long_name: string;
            short_name: string;
            types: string[];
          };
          streetNumber: {
            long_name: string;
            short_name: string;
            types: string[];
          };
          street: {
            long_name: string;
            short_name: string;
            types: string[];
          };
          position: { lang: string; long: string };
        }
      | undefined
    >
  >;
  positions:
    | {
        lat: number;
        lng: number;
      }
    | undefined;
  setPositions: Dispatch<
    SetStateAction<{
      lat: number;
      lng: number;
    }>
  >;
}

const MapContext = createContext<IMapContext>(null);

export const useMap = () => {
  return useContext(MapContext);
};

export const MapProvider = ({ children }) => {
  const [isMapVisible, setIsMapVisible] = useState(false);
  const [chosenLocation, setChosenLocation] = useState();
  const [positions, setPositions] = useState();

  const openMap = () => {
    setIsMapVisible(true);
  };

  const resetMapState = () => {
    setIsMapVisible(false);
    setChosenLocation(undefined);
  };

  const closeMap = () => {
    setIsMapVisible(false);
  };

  return (
    <MapContext.Provider
      value={{
        openMap,
        resetMapState,
        closeMap,
        isMapVisible,
        setIsMapVisible,
        chosenLocation,
        setChosenLocation,
        positions,
        setPositions,
      }}
    >
      {children}
    </MapContext.Provider>
  );
};
